/**
 * `?dev-session=<first name>` (mock only): sign in as a seeded person with first-run done, for screenshots and
 * quick demos; `asha` is Asha Rao, Owner of Northlight Studio, and `out` signs out. The parameter is removed from
 * the address bar before the app renders.
 */
export const DEV_SESSION_PARAM = "dev-session";

export function consumeDevSessionParam(
  location: Location = window.location,
  history: History = window.history,
): string | undefined {
  const params = new URLSearchParams(location.search);
  const value = params.get(DEV_SESSION_PARAM);
  if (value === null) return undefined;
  params.delete(DEV_SESSION_PARAM);
  const query = params.toString();
  history.replaceState(
    history.state,
    "",
    `${location.pathname}${query === "" ? "" : `?${query}`}${location.hash}`,
  );
  return value.trim().toLowerCase();
}
